import { STATUSES } from './statuses';

export const STATUSES_FOR_FILTERING: Array<{
  id: string;
  name: string;
}> = Object.keys(STATUSES).reduce((acc, cur) => {
  // @ts-expect-error TS(2322): Type 'any' is not assignable to type 'never'.
  acc.push({ id: cur, name: STATUSES[cur] });
  return acc;
}, []);
